import React, { Fragment, useState, useEffect } from 'react'
import SwitchMenuBar from '../../Components/SwitchMenuBar/SwitchMenuBar'
import '../Bookings2/JobList.css'
import JobBoardComponent from './BookingComponent'
import { Pagination } from 'semantic-ui-react'
import { Dropdown, Menu, Responsive } from 'semantic-ui-react'
import AdminWrapper from './AdminWrapper'
import { API } from '../../API'
import { teacherStatus } from '../../Helper'
import SearchBar from '../../Components/SearchBar/SearchBar'
import FormDropdown from '../../Components/FormField/FormDropdown'
import FormDatePicker2 from '../../Components/FormField/FormDatePicker2'
import { getTotalPages, extractDataOfCurrPage } from '../../Helper/PagingHelper'

const Moment = require('moment')
const MomentRange = require('moment-range')
const moment = MomentRange.extendMoment(Moment)

const BookingSortedBy = {
  Date: 'BookingDate',
  TeacherAllocated: 'TeacherAllocated',
  TeacherUnAllocated: 'TeacherUnAllocated',
  SingleDate: 'SingleDate',
  DateRange: 'DateRange',
}

const bookingDict = {}
const campusDict = {}

const AssignBookings = () => {
  let [isAllBookinngsLoaded, setAllBookinngsLoaded] = useState(false)
  let [allUsers, setAllUsers] = useState([])
  let [allBookings, setAllBookings] = useState([])
  let [filteredBookings, setFilteredBookings] = useState([])
  let [allCampus, setAllCampus] = useState([])
  let [allInst, setAllInst] = useState([])
  let [pageNum, setPageNum] = useState(1)
  let [totalPages, setTotalPages] = useState(1)
  let [rowsOption, setRowsOption] = useState(5)
  let [showCurrentBookings, setShowCurrentBookings] = useState([])
  let [date, setDate] = useState()

  useEffect(() => {
    async function fetchData() {
      await getAllBookingsOfUser()
      await getAllCampus()
      await getAllInst()
      await getAllUsers()
    }

    fetchData()
  }, [])

  useEffect(() => {
    groupBookingsBasedOnId()
  }, [allCampus])

  const getAllUsers = async () => {
    try {
      await API.allTeachers()
        .then(function (result) {
          setAllUsers(result.data)
        })
        .catch(function (err) {
          console.log(err)
        })
    } catch (error) {
      alert(error)
    }
  }

  const getAllBookingsOfUser = async () => {
    try {
      API.getAllBookings()
        .then(function (result) {
          setAllBookinngsLoaded(true)
          setAllBookings(result.data)
          setFilteredBookings(result.data)
          calculatePageCount(result.data, rowsOption)
          extractBookingsOfCurrPage(pageNum, result.data, rowsOption)
        })
        .catch(function (err) {
          console.log(err)
        })
    } catch (error) {
      alert(error)
    }
  }

  const getAllCampus = async () => {
    try {
      API.getAllCampus()
        .then(function (result) {
          setAllCampus(result.data)
        })
        .catch(function (err) {
          console.log(err)
        })
    } catch (error) {
      alert(error)
    }
  }

  const getAllInst = async () => {
    try {
      API.getAllInst()
        .then(function (result) {
          setAllInst(result.data)
        })
        .catch(function (err) {
          console.log(err)
        })
    } catch (error) {
      alert(error)
    }
  }

  const calculatePageCount = (bookings, rowsOption) => {
    const pageCount = getTotalPages(bookings, rowsOption)
    setTotalPages(pageCount)
  }

  const bookingDataChangedCallback = async (bookingList) => {
    setShowCurrentBookings(bookingList)
  }

  const extractBookingsOfCurrPage = (pageNumber, bookings, rowsOption) => {
    extractDataOfCurrPage(
      pageNumber,
      bookings,
      rowsOption,
      bookingDataChangedCallback,
      setPageNum
    )
  }

  const updatePagingData = (filteredData, rowsOption) => {
    setPageNum(1)
    setFilteredBookings(filteredData)
    calculatePageCount(filteredData, rowsOption)
    extractBookingsOfCurrPage(1, filteredData, rowsOption)
  }

  const queryInstitutionId = (booking) => {
    let result = null
    const campus = allCampus.find((el) => el._id == booking.campus_id)
    if (campus) {
      result = campus.institution_id
    }

    return result
  }

  const queryTeacherName = (teacher_id) => {
    const foundTeacher = allUsers.find((item) => item._id === teacher_id)
    return foundTeacher
      ? foundTeacher.first_name + ' ' + foundTeacher.last_name
      : ''
  }

  const getLastBookingTeacherAllocation = (booking) => {
    const teacherList = []
    const instId = queryInstitutionId(booking)
    const bookingList = bookingDict[instId] || null
    if (bookingList) {
      let currentTime = new Date(booking.end_booking_date).getTime()
      const lastBooking = bookingList.find((item) => {
        let comparedTime = new Date(item.end_booking_date).getTime()
        return comparedTime < currentTime
      })

      if (lastBooking) {
        lastBooking.splits.forEach((spl) => {
          const name = queryTeacherName(spl.teacher_id)
          teacherList.push(name)
        })
      }
    }

    return teacherList
  }

  const groupBookingsBasedOnId = () => {
    if (allBookings) {
      allBookings.forEach((item) => {
        let campus = campusDict[item.campus_id] || null
        if (campus == null) {
          campus = allCampus.find((el) => el._id == item.campus_id)
          campusDict[item.campus_id] = campus
        }

        if (campus != null) {
          let bookings = bookingDict[campus.institution_id] || null
          if (bookings == null) {
            bookings = []
            bookingDict[campus.institution_id] = bookings
          }

          bookings.push(item)
        }
      })
    }

    for (const [key, value] of Object.entries(bookingDict)) {
      value.sort(compareBookingEndDate)
    }
  }

  const isTeacherAssigned = (booking) => {
    return booking.teacher_status === teacherStatus.not_assigned ? false : true
  }

  const compareDateOfBooking = (firstTime, secondTime) => {
    if (firstTime > secondTime) {
      return -1
    } else if (firstTime < secondTime) {
      return 1
    } else {
      return 0
    }
  }

  const compareBookingDate = (first, second) => {
    let firstTime = new Date(first.booking_date).getTime()
    let secondTime = new Date(second.booking_date).getTime()

    return compareDateOfBooking(firstTime, secondTime)
  }

  const compareBookingEndDate = (first, second) => {
    let firstTime = new Date(first.end_booking_date).getTime()
    let secondTime = new Date(second.end_booking_date).getTime()

    return compareDateOfBooking(firstTime, secondTime)
  }

  const compareAssignedTeacherStatus = (first, second, greaterValue) => {
    let compVal = 0

    let firstStatus = isTeacherAssigned(first)
    let secondStatus = isTeacherAssigned(second)

    if (firstStatus === true && secondStatus === false) {
      compVal = greaterValue
    } else if (firstStatus === false && secondStatus === true) {
      compVal = -greaterValue
    } else {
      compVal = compareBookingDate(first, second)
    }

    return compVal
  }

  const compareTeacherAllocated = (first, second) => {
    return compareAssignedTeacherStatus(first, second, -1)
  }

  const compareTeacherUnAllocated = (first, second) => {
    return compareAssignedTeacherStatus(first, second, 1)
  }

  const compareMultipleDate = (first, second, singleBefore) => {
    let compVal = 0

    if (first.multiple_date === true && second.multiple_date === false) {
      compVal = singleBefore
    } else if (first.multiple_date === false && second.multiple_date === true) {
      compVal = -singleBefore
    } else {
      compVal = compareBookingDate(first, second)
    }

    return compVal
  }

  const compareSingleDate = (first, second) => {
    return compareMultipleDate(first, second, 1)
  }

  const compareDateRange = (first, second) => {
    return compareMultipleDate(first, second, -1)
  }

  const handleSortByChanged = (e) => {
    let sortBy = e.target.value
    switch (sortBy) {
      case BookingSortedBy.Date:
        filteredBookings.sort(compareBookingDate)
        updatePagingData(filteredBookings, rowsOption)
        break
      case BookingSortedBy.TeacherAllocated:
        filteredBookings.sort(compareTeacherAllocated)
        updatePagingData(filteredBookings, rowsOption)
        break
      case BookingSortedBy.TeacherUnAllocated:
        filteredBookings.sort(compareTeacherUnAllocated)
        updatePagingData(filteredBookings, rowsOption)
        break
      case BookingSortedBy.SingleDate:
        filteredBookings.sort(compareSingleDate)
        updatePagingData(filteredBookings, rowsOption)
        break
      case BookingSortedBy.DateRange:
        filteredBookings.sort(compareDateRange)
        updatePagingData(filteredBookings, rowsOption)
        break
    }
  }

  const searchByName = (e) => {
    let searchItem = e.target.value.toLowerCase()
    if (searchItem.length > 0) {
      const bookings = allBookings

      if (bookings.length > 0) {
        let filter_bookings = bookings.filter((b) => {
          let searchString = ''

          if (typeof b.level !== 'undefined' && b.level) {
            searchString += b.level
          }

          const jobCampus = allCampus.find(
            (campus) => campus._id === b.campus_id
          )
          const jobInst = jobCampus
            ? allInst.find((inst) => inst._id === jobCampus.institution_id)
            : 0

          if (
            typeof jobCampus !== 'undefined' &&
            typeof jobCampus.address_line1 !== 'undefined'
          ) {
            searchString += jobCampus.address_line1
          }

          if (
            typeof jobCampus !== 'undefined' &&
            typeof jobCampus.address_line2 !== 'undefined'
          ) {
            searchString += jobCampus.address_line2
          }

          if (
            typeof jobInst !== 'undefined' &&
            typeof jobInst.inst_shortname !== 'undefined'
          ) {
            searchString += jobInst.inst_shortname
          }

          if (!searchString.length) {
            return false
          }

          searchString = searchString.toLowerCase()
          return searchString.indexOf(searchItem) !== -1
        })
        updatePagingData(filter_bookings, rowsOption)
      }
    } else {
      updatePagingData(allBookings, rowsOption)
    }
  }

  const searchByDate = (date) => {
    setDate(date)

    if (date && allBookings.length) {
      let formattedDate = moment(date).format('YYYY-MM-DD')
      let filter_bookings = allBookings.filter((b) => {
        if (b.multiple_date) {
          return (
            b.booking_date <= formattedDate &&
            b.end_booking_date >= formattedDate
          )
        } else {
          return b.booking_date === formattedDate
        }
      })
      setShowCurrentBookings(filter_bookings)
    } else {
      setShowCurrentBookings(allBookings)
    }
  }

  const onPageNumChange = (e) => {
    extractBookingsOfCurrPage(
      e.target.getAttribute('value'),
      filteredBookings,
      rowsOption
    )
  }

  const onRowsChange = (e) => {
    setRowsOption(parseInt(e.target.innerText))
    updatePagingData(filteredBookings, parseInt(e.target.innerText))
  }

  const rOptions = [
    {
      key: '5',
      text: '5',
      value: parseInt('5'),
    },
    {
      key: '10',
      text: '10',
      value: parseInt('10'),
    },
    {
      key: '15',
      text: '15',
      value: parseInt('15'),
    },
  ]
  return (
    <AdminWrapper>
      {/* Menu area */}
      <SwitchMenuBar isViewAsTeacher />
      <div className='container-wrapper-JobList'>
        <div className='linear-gradient-JobList'>
          {/* Body area */}
          <div className='body-main-page-JobList'>
            <div className='d-flex justify-start ml-20 '>
              <p className='text-3xl font-bold flex flex-col justify-center ml-10'>
                All bookings
              </p>
            </div>

            <div className='search-picker-container'>
              <div className='datepicker-style'>
                <FormDatePicker2
                  placeholderText='Search by Date'
                  selected={date}
                  onChange={searchByDate}
                  isClearable
                  dateFormat='dd-MM-yyyy'
                  className='datepicker-2'
                />
              </div>
              <div className='d-flex mx-10'>
                <SearchBar
                  placeholder='Search by Keyword'
                  onChange={searchByName}
                />
              </div>
              <div className='d-flex'>
                <FormDropdown
                  id='booking-sort-by'
                  icon='sort'
                  onChange={handleSortByChanged}
                  placeholder='Sort By'
                  required
                >
                  <option value='BookingDate'>
                    Booking most recently made
                  </option>
                  <option value='TeacherAllocated'>Allocated</option>
                  <option value='TeacherUnAllocated'>Unallocated</option>
                  <option value='SingleDate'>Single Date</option>
                  <option value='DateRange'>Date Range</option>
                </FormDropdown>
              </div>
            </div>

            <div>
              {!showCurrentBookings.length ? (
                <p></p>
              ) : (
                <Fragment>
                  {showCurrentBookings.map((job) => (
                    <Fragment key={job._id}>
                      {/* added new value bookings - lieh */}
                      <JobBoardComponent
                        job={job}
                        bookings={allBookings}
                        users={allUsers}
                        campuses={allCampus}
                        insts={allInst}
                        queryLastBooking={getLastBookingTeacherAllocation}
                      />
                    </Fragment>
                  ))}
                  <div className='row bookings-bottom pb-0'>
                    <div className='col-lg-3 col-md-0 '></div>
                    <div className='col-lg-5  col-md-12 bookings-bottom-pagination'>
                      <Responsive minWidth={1500}>
                        <Pagination
                          totalPages={totalPages}
                          siblingRange={1}
                          ellipsisItem={false}
                          firstItem={false}
                          lastItem={false}
                          onPageChange={(e) => onPageNumChange(e)}
                          activePage={pageNum}
                        />
                      </Responsive>
                      <Responsive minWidth={1200} maxWidth={1499}>
                        <Pagination
                          totalPages={totalPages}
                          ellipsisItem={false}
                          firstItem={false}
                          lastItem={false}
                          boundaryRange={0}
                          siblingRange={1}
                          onPageChange={(e) => onPageNumChange(e)}
                          activePage={pageNum}
                        />
                      </Responsive>
                      <Responsive maxWidth={1199}>
                        <Pagination
                          totalPages={totalPages}
                          ellipsisItem={false}
                          firstItem={false}
                          lastItem={false}
                          boundaryRange={0}
                          siblingRange={0}
                          onPageChange={(e) => onPageNumChange(e)}
                          activePage={pageNum}
                        />
                      </Responsive>
                    </div>
                    <div className='col-lg-2 rows-per-page-show-1'>
                      <Responsive minWidth={1200}>Rows Per Page:</Responsive>
                    </div>
                    <div className='col-lg-1  col-md-12 col-xs-12 rows-per-page-show-2'>
                      <Menu compact>
                        <Dropdown
                          id='dropdown-bookings'
                          selection
                          fluid
                          options={rOptions}
                          defaultValue={rowsOption}
                          simple
                          item
                          onChange={(e) => onRowsChange(e)}
                          style={{ width: '50px', height: '25px' }}
                        />
                      </Menu>
                    </div>
                    <div className='col-lg-1 col-md-12'></div>
                  </div>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </AdminWrapper>
  )
}

export default AssignBookings
